/**
 * F-password-eye — input de senha com botão de mostrar/ocultar (olho).
 * Repassa todas as props de um <input> normal; só controla o `type`.
 */

import { useState, type InputHTMLAttributes } from "react";
import { useT } from "../../i18n/index.js";

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, "type">;

export function PasswordInput({ className = "", ...rest }: Props) {
  const t = useT();
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input type={show ? "text" : "password"} className={`${className} pr-10`} {...rest} />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        tabIndex={-1}
        aria-label={show ? t("common.hidePassword") : t("common.showPassword")}
        title={show ? t("common.hidePassword") : t("common.showPassword")}
        className="absolute inset-y-0 right-0 flex items-center px-3 text-base leading-none opacity-70 hover:opacity-100"
      >
        {show ? "🙈" : "👁️"}
      </button>
    </div>
  );
}
